<template>
  <div class="dashboard">
    <h1>Dashboard</h1>

    <div class="w-full flex flex-row-reverse">
      <el-button type="text" @click="logout">Logout</el-button>
    </div>

    <div class="mt-10 w-1/4">
      <small>Generate invite code</small>
      <el-input class="mt-4" v-model="inviteCode" placeholder readonly>
        <el-button type="primary" @click="generateInviteCode" slot="append"
          >Generate</el-button
        >
      </el-input>
    </div>

    <ul class="mt-10 mb-10 flex">
      <li class="mini-stat">
        <label>Cash balance</label>
        <h2>{{ formatMoney(this.stats.cash_balance) }}</h2>
      </li>
      <li class="mini-stat">
        <label>Credit line</label>
        <h2>{{ formatMoney(this.stats.credit_line) }}</h2>
      </li>
      <li class="mini-stat">
        <label>Unspent credit line</label>
        <h2>{{ formatMoney(this.stats.unspent_credit_line) }}</h2>
      </li>
    </ul>

    <div class="stats mt-10 flex flex-wrap justify-between">
      <div class="stat">
        <label>Interest accrued</label>
        <h2 class="mb-6">
          {{
            formatMoney(
              this.stats.interest_accrued[
                this.stats.interest_accrued.length - 1
              ].value
            )
          }}
        </h2>
        <area-chart :data="interestAccruedData.data" thousands="," prefix="₦" />
      </div>
      <div class="stat">
        <label>Repayment accrued</label>
        <h2 class="mb-6">
          {{
            formatMoney(
              this.stats.repayment_accrued[
                this.stats.repayment_accrued.length - 1
              ].value
            )
          }}
        </h2>
        <area-chart
          :data="repaymentAccruedData.data"
          thousands=","
          prefix="₦"
        />
      </div>
      <div class="stat">
        <label>Deposit volume</label>
        <h2 class="mb-6">{{ formatMoney(depositVolumeData.sum) }}</h2>
        <area-chart :data="depositVolumeData.data" thousands="," prefix="₦" />
      </div>
      <div class="stat">
        <label>Spend volume</label>
        <h2 class="mb-6">{{ formatMoney(spendVolumeData.sum) }}</h2>
        <area-chart :data="spendVolumeData.data" thousands="," prefix="₦" />
      </div>
      <div class="stat">
        <label>Total credit spent daily</label>
        <h2 class="mb-6">{{ formatMoney(totalCreditData.sum) }}</h2>
        <area-chart :data="totalCreditData.data" thousands="," prefix="₦" />
      </div>
    </div>
  </div>
</template>

<script>
import { CREATE_INVITE_CODE_MUTATION } from "@/api/mutations";
import { ADMIN_STATS } from "@/api/queries";

export default {
  apollo: {
    stats: {
      query: ADMIN_STATS,
      update: data => data.adminStats
    }
  },
  computed: {
    totalCreditData() {
      return this.mapStats("total_credit_spent");
    },
    interestAccruedData() {
      return this.mapStats("interest_accrued");
    },
    repaymentAccruedData() {
      return this.mapStats("repayment_accrued");
    },
    depositVolumeData() {
      return this.mapStats("deposit_volume");
    },
    spendVolumeData() {
      return this.mapStats("spend_volume");
    }
  },
  data() {
    return {
      inviteCode: "",
      stats: {
        total_credit_spent: [],
        interest_accrued: [],
        deposit_volume: [],
        spend_volume: []
      },
      formatter: new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: "NGN"
      })
    };
  },
  methods: {
    async generateInviteCode() {
      const { data } = await this.$apollo.mutate({
        mutation: CREATE_INVITE_CODE_MUTATION
      });
      this.inviteCode = data.createInviteCode.inviteCode.code;
    },
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    },
    mapStats(name) {
      const result = { data: {}, sum: 0 };
      const entries = this.stats[name];
      for (let i = 0; i < entries.length; i++) {
        result.data[entries[i].day] = entries[i].value;
        result.sum += parseFloat(entries[i].value);
      }

      return result;
    },
    formatMoney(amount) {
      return this.formatter.format(amount);
    }
  }
};
</script>

<style lang="scss">
.stat {
  margin-bottom: 3rem;
  width: 48%;

  canvas {
    background: rgb(236, 236, 236);
  }
}

.mini-stat {
  background: white;
  padding: 1.6rem;
  border-radius: 1rem;
  min-width: 20rem;
  border: 0.1rem solid rgb(235, 235, 235);
  margin-right: 2.4rem;
}
</style>
